import { AxiosInstance } from "axios";
import {
  BackendCartRequest,
  BackendPackageListResponse
} from "@/interfaces/packages/sales_packages";

export const updateCart = async (
  client: AxiosInstance,
  cart: BackendCartRequest[]
) => await client.post("meeting_state/add_package", { cart });

export const packagesList = async (client: AxiosInstance) =>
  (await client.get<BackendPackageListResponse>("packages")).data;
